import { CallsAlertsSearchBarValues } from "../types";
import buildAndCleanQueryString from "./buildAndCleanQueryString";
import cleanInitialStateFromQuery from "./cleanInitialStateFromQuery";
import { getApiFormattedDate } from "./dateFormatter";

export default function formatGetCallQueryString(options: {
  searchParams: URLSearchParams;
  isFirstLoad?: boolean;
  initialQuery?: string;
}) {
  const { searchParams, isFirstLoad, initialQuery } = options;

  const hasNoSearchParams = searchParams.toString().length === 0;

  if (isFirstLoad && hasNoSearchParams) {
    return initialQuery;
  }

  let UrlParamsObj = cleanInitialStateFromQuery(
    Object.fromEntries(searchParams),
    ["fromTradeDate", "toTradeDate", "fromDueDate", "toDueDate"]
  );

  const {
    amountMaxRaw,
    amountMinRaw,
    eventName,
    callType,
    fromTradeDate,
    toTradeDate,
    fromDueDate,
    toDueDate,
    accountId,
  } = UrlParamsObj as CallsAlertsSearchBarValues;

  const remappedValuesForAPI = {
    ...UrlParamsObj,
    account: accountId,
    eventCodes: callType,
    eventNames: eventName && eventName[0] === "OTHER" ? "" : eventName,
    minAmount: amountMinRaw,
    maxAmount: amountMaxRaw,
    fromTradeDate: fromTradeDate ? getApiFormattedDate(fromTradeDate) : "",
    toTradeDate: toTradeDate ? getApiFormattedDate(toTradeDate) : "",
    fromDueDate: fromDueDate ? getApiFormattedDate(fromDueDate) : "",
    toDueDate: toDueDate ? getApiFormattedDate(toDueDate) : "",
  };

  return buildAndCleanQueryString(remappedValuesForAPI, {
    exclude: [
      "accountId",
      "callType",
      "eventName",
      "amountMinDisplay",
      "amountMinRaw",
      "amountMaxDisplay",
      "amountMaxRaw",
      "type",
    ],
  });
}
